import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { applicationsAPI } from "../api/applicationsApi";
import { GetIndividualIssuanceParams, IndividualIssuanceResponse } from "../types/applicationsTypes";

export const getIndividualIssuanceByMarathonId = createAsyncThunk<
  IndividualIssuanceResponse,
  GetIndividualIssuanceParams,
  { rejectValue: string }
>
  (
    'admin/getIndividualIssuanceByMarathonId',
    async (data: GetIndividualIssuanceParams, { rejectWithValue }) => {
      try {
        const response = await applicationsAPI.getIndividualIssuanceByMarathonId(data);
        return response.data;
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Ошибка на сервере';
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return rejectWithValue('Ошибка на сервере');
      }
    }
  )
